import React from "react";
import { LinearProgress } from "@mui/material";

export default function InputLoader({ className, color = "brand" }) {
  return (
    <LinearProgress
      className={"input-loader " + className}
      classes={{
        bar: `bg-${color}`,
      }}
    />
  );
}
